// recoil
import { atom } from 'recoil';

// local forage
import localForage from 'localforage';

const localIndexedDBEffect =
    (key) =>
    ({ setSelf, onSet, trigger }) => {
        const loadPersisted = async () => {
            // set loading for async operation
            setSelf((prevState) => ({ ...prevState, async: { loading: true } }));

            const value = await localForage.getItem(key);
            if (value) {
                setSelf((prevState) => ({ ...prevState, ...value, async: { loading: false } }));
            } else {
                setSelf((prevState) => ({ ...prevState, async: { loading: false } }));
            }
        };

        if (trigger === 'get') {
            loadPersisted();
        }

        onSet((newValue, oldValue, isReset) => {
            if (isReset) {
                localForage.removeItem(key);
            } else {
                localForage.setItem(key, newValue);
            }
        });
    };

const PermanentDefault = {};

const PermanentState = atom({
    key: 'PermanentState',
    default: PermanentDefault,
    effects: [localIndexedDBEffect('permanence')],
});

export { PermanentState };
